import { Typography } from 'antd';

import { CD_FULL_DAY_HEIGHT } from '@app/components/Calendars/components/Dashboard/constants';
import type { FullDayTasksType } from '@app/components/Calendars/components/TimeColumn/types';
import { Popover } from '@app/components/Popover';

import '@app/components/Calendars/components/TimeColumn/styles/FullDayTasks.desktop.scss';

const { Text } = Typography;

export const FullDayTasks: FullDayTasksType = ({
  tasks,
  openPreviewTaskModal,
}) => {
  const hasExtraHeightTasks = tasks.length > 4;

  const mainTasks = hasExtraHeightTasks ? tasks.slice(0, 3) : tasks;

  const extraTasks = hasExtraHeightTasks ? tasks.slice(3) : [];

  return (
    <div
      className="full-day-task-container"
      style={{ height: CD_FULL_DAY_HEIGHT }}
    >
      {mainTasks.map(({ id, title, status }) => (
        <div
          key={id}
          className="task"
          onClick={() => openPreviewTaskModal(+id)}
          data-status={status}
        >
          {title}
        </div>
      ))}
      {hasExtraHeightTasks && (
        <Popover
          strategy="fixed"
          offsetPx={6}
          component={(isOpen, open, close) => (
            <Text
              className="full-width more-button"
              onClick={isOpen ? close : open}
            >
              Еще {extraTasks.length}
            </Text>
          )}
          content={() => (
            <div className="full-day-task-popover-container">
              {extraTasks.map(({ id, title, status }) => (
                <div
                  key={id}
                  className="task"
                  onClick={() => openPreviewTaskModal(+id)}
                  data-status={status}
                >
                  {title}
                </div>
              ))}
            </div>
          )}
          contentClassName="full-day-task-popover"
        />
      )}
    </div>
  );
};
